import React from 'react';
export function JealousFinalCTA() {
  return <section id="final-cta" className="w-full py-28 px-4 text-center relative overflow-hidden" style={{
    backgroundColor: '#2E7AB5'
  }} data-id="element-252">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-253">
        <img src="https://cdn.magicpatterns.com/uploads/1HF2jqS9t17ndiKosJS6N4/2024-04-25.webp" alt="" className="w-full h-full object-cover opacity-15" data-id="element-254" />
        <div className="absolute inset-0" style={{
        backgroundColor: 'rgba(46,122,181,0.85)'
      }} data-id="element-255" />
      </div>
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-256">
        <p className="mb-4" style={{
        color: '#DCE9F3',
        fontFamily: '"Plus Jakarta Sans", sans-serif',
        fontWeight: 700,
        fontSize: '13px',
        letterSpacing: '1px',
        textTransform: 'uppercase'
      }} data-id="element-257">
          LIMITED AVAILABILITY
        </p>
        <h2 className="mb-8" style={{
        color: '#FFFFFF',
        fontFamily: '"Plus Jakarta Sans", sans-serif',
        fontWeight: 800,
        fontSize: 'clamp(32px, 5vw, 44px)',
        letterSpacing: '-0.02em',
        lineHeight: 1.2
      }} data-id="element-258">
          Ready for a Home That Turns Heads?
        </h2>

        <div className="flex items-center justify-center gap-4 mb-6" data-id="element-259">
          <span style={{
          color: 'rgba(255,255,255,0.6)',
          fontFamily: '"Plus Jakarta Sans", sans-serif',
          fontWeight: 700,
          fontSize: '24px',
          textDecoration: 'line-through'
        }} data-id="element-260">
            $500
          </span>
          <span style={{
          color: '#FFFFFF',
          fontFamily: '"Plus Jakarta Sans", sans-serif',
          fontWeight: 800,
          fontSize: '56px',
          lineHeight: 1,
          letterSpacing: '-0.02em'
        }} data-id="element-261">
            $167
          </span>
        </div>

        <p className="mb-10 mx-auto max-w-[500px]" style={{
        color: 'rgba(255,255,255,0.9)',
        fontFamily: '"Plus Jakarta Sans", sans-serif',
        fontSize: '18px',
        lineHeight: 1.5
      }} data-id="element-262">
          Lock in your 67% discount today. Only 10 spots available per week.
        </p>

        <a href="tel:4805998442" className="inline-block w-full sm:w-auto text-center transition-all hover:-translate-y-1 mb-6" style={{
        backgroundColor: '#F27A3A',
        color: '#FFFFFF',
        fontFamily: '"Plus Jakarta Sans", sans-serif',
        fontWeight: 700,
        fontSize: '20px',
        padding: '20px 48px',
        borderRadius: '8px',
        boxShadow: '0 4px 14px rgba(242,122,58,0.3)'
      }} data-id="element-263">
          📞 Call (480) 599-8442 to Book
        </a>

        <p style={{
        color: 'rgba(255,255,255,0.6)',
        fontFamily: '"Plus Jakarta Sans", sans-serif',
        fontSize: '12px',
        maxWidth: '400px',
        margin: '0 auto'
      }} data-id="element-264">
          By reaching out, you agree to receive texts from Blue Cactus Power
          Washing. Msg &amp; data rates may apply. Reply STOP to unsubscribe.
        </p>
      </div>
    </section>;
}